(() => {
  if (window.StellarStoryLibrary) return;
  const settings = () => {
    const el = document.querySelector('[data-story-library-settings]');
    return el ? JSON.parse(el.textContent) : null;
  };
  const sections = () => [...document.querySelectorAll('[data-story-library-items]')].map(el => JSON.parse(el.textContent));
  window.StellarStoryLibrary = {
    feed(snapshot, productId) {
      const config = settings();
      if (!config || config.source !== 'library') return snapshot.feeds[productId];
      const originals = new Map();
      for (const feed of Object.values(snapshot.feeds)) for (const item of feed.items || []) if (!originals.has(item.url)) originals.set(item.url, item);
      // Preserve each product page's original linked-product priority when that selection is unchanged.
      const pageOriginals = new Map((snapshot.feeds[productId]?.items || []).map(item => [item.url, item]));
      const items = [], seen = new Set();
      for (const section of sections()) for (const entry of section.items) {
        if (!entry.enabled || !entry.pages.includes(productId)) continue;
        const original = pageOriginals.get(entry.original) || originals.get(entry.original);
        const url = entry.url || entry.original;
        if (!url || seen.has(url)) continue;
        seen.add(url);
        const selectedIds = entry.products.map(p => p.id);
        const sameProducts = original && original.products.length === selectedIds.length && original.products.every(p => selectedIds.includes(String(p.id)));
        let products = sameProducts ? original.products.map(p => ({...p})) : entry.products.map(p => ({id:p.id,variantIds:[]}));
        if (!sameProducts) products = products.filter(p => p.id === productId).concat(products.filter(p => p.id !== productId));
        for (const product of entry.products) snapshot.products[product.id] = product;
        const replaced = !!entry.url;
        items.push({
          ...(original || {}), id:original?.id || 'library-' + entry.blockId, type:'video',
          url, preview:entry.preview || (replaced ? url : original?.preview || url),
          poster:entry.poster || (replaced ? '' : original?.poster || ''),
          caption:entry.caption || '',
          captions:entry.removeSubtitles ? '' : entry.captions || ((!replaced || url === original?.url || entry.keepOriginalSubtitles) ? original?.captions || '' : ''),
          captionLanguage:entry.captionLanguage || original?.captionLanguage || 'en',
          captionLabel:entry.captionLabel || original?.captionLabel || '',
          products, editorBlockId:entry.blockId, editorTitle:entry.title
        });
      }
      return {disabled:items.length === 0,order:config.order,items};
    }
  };
  if (!window.Shopify?.designMode) return;
  let refresh;
  const changed = event => {
    if (!event.target.matches?.('[data-story-library-editor]') && !event.target.querySelector?.('[data-story-library-editor]')) return;
    clearTimeout(refresh);
    refresh = setTimeout(() => document.dispatchEvent(new CustomEvent('stellar:story-library-change')), 0);
  };
  for (const name of ['shopify:section:load','shopify:section:unload','shopify:section:reorder']) document.addEventListener(name, changed);
  document.addEventListener('shopify:block:select', event => {
    const blockId = event.detail?.blockId;
    for (const gallery of document.querySelectorAll('.ssv2--stories')) {
      const index = gallery.items?.findIndex(item => item.editorBlockId === blockId);
      if (!(index >= 0)) continue;
      gallery.scrollIntoView({block:'center',behavior:'auto'});
      const tile = gallery.track?.querySelector('[data-index="' + index + '"]');
      tile?.scrollIntoView({block:'nearest',inline:'center',behavior:'auto'});
      tile?.querySelector('button')?.focus({preventScroll:true});
    }
  });
})();
